import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobe,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import styles from "./style.module.css";
import moment from "moment";
import CustomCarousel from "../../Components/Carousel";
import { Table } from "react-bootstrap";
import { Pagination } from "../../Components/Pagination";

export default function LogsTagContainer() {
  const { proxy, lang } = useSelector((state) => state);
  const [data, setData] = useState([]);
  const param = useParams();
  const [loading, setLoading] = useState(true);
  const [search, setSeach] = useState();
  const debounceTimeout = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 14;
  const indexOfLastData = currentPage * itemsPerPage;
  const indexOfFirstData = indexOfLastData - itemsPerPage;
  const { HinhAnh, message, ThongTin = [], DanhSachTemRFID } = data || {};

  const currentData =
    DanhSachTemRFID &&
    DanhSachTemRFID?.fields.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  function formatDate(data, isDate) {
    const date = data ? moment.utc(data).format("DD/MM/YYYY HH:mm:ss") : "";
    if (isDate && date.toString() !== "Invalid date") {
      return { data: date, isUnsetColor: true };
    }
    return { data };
  }

  const fetchData = (search) => {
    const safeSearch = search || {};

    const cleanedSearch = Object.fromEntries(
      Object.entries(safeSearch).map(([key, value]) => [
        key?.trim?.() || "",
        value?.trim?.() || "",
      ])
    );

    const searchParams = new URLSearchParams(cleanedSearch).toString();

    fetch(`${proxy()}/api/logsTag/${param.tagSling}?${searchParams}`, {
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (search) {
      setCurrentPage(1);

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      const value = typeof search === "string" ? search.trim() : search;
      debounceTimeout.current = setTimeout(async () => {
        fetchData(value);
      }, 1000);
    } else {
      fetchData();
    }
  }, [param.tagSling, search]);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.logo}>
          <img src="/images/logo/logodpm.png" alt="logo" />
        </div>
      </div>
      <main className={styles.custom_main}>
        <div className={styles.content}>
          {message ? (
            <div className={styles.condition}>{message}</div>
          ) : (
            // : !SanPham ? (
            //   <div className={styles.condition}>không tìm thấy thông tin</div>
            // )
            <>
              <div>
                {HinhAnh?.length > 0 ? (
                  <CustomCarousel imgs={HinhAnh} proxy={proxy} />
                ) : null}
                {/* <div className={styles.title} style={{ color: EPC?.color }}>
                  tem sản phẩm {EPC?.MoTaTrangThai}
                </div>
                <div className={styles.title}>{SanPham?.TieuDe}</div>
                <div
                  className={styles.custom_p}
                  dangerouslySetInnerHTML={{ __html: SanPham?.MoTa || "" }}
                ></div> */}
              </div>
              <>
                {ThongTin?.map((item, index) => (
                  <div key={index} className={styles.event}>
                    <div
                      className={styles.title}
                      style={{ color: item?.color }}
                    >
                      {item?.TieuDe}
                    </div>

                    {item?.fields?.map((field, index) => {
                      const { data, isUnsetColor } = formatDate(
                        field?.value,
                        field?.isDate
                      );
                      return (
                        <div key={index} className="ml-3 mb-2">
                          <div className={styles.field_title}>
                            {field?.title}:
                            <span
                              className={`${styles.field_content} ${styles.custom_span}`}
                              style={{
                                color: isUnsetColor ? "unset" : "",
                                fontWeight: field?.isDefault && "bold",
                              }}
                            >
                              {data}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </>
              <>
                {DanhSachTemRFID && (
                  <>
                    <Table
                      className="table-custom design-table table-responsive"
                      style={{
                        height: "50vh",
                      }}
                    >
                      <thead>
                        <tr>
                          <td
                            className="align-center"
                            color="#888787"
                            width={1}
                            style={{
                              color: "#888787",
                            }}
                          >
                            #
                          </td>
                          {DanhSachTemRFID?.titles?.map(({ title }, index) => (
                            <td
                              key={index}
                              className="align-center"
                              style={{
                                color: "#888787",
                                width: "unset",
                              }}
                            >
                              {title}
                            </td>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          <tr
                            style={{
                              position: "sticky",
                              top: "45px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <td></td>
                            {DanhSachTemRFID?.titles?.map(
                              ({ value: alias }) => (
                                <td
                                  key={alias}
                                  style={{
                                    width: "unset",
                                  }}
                                >
                                  <input
                                    type="search"
                                    className="form-control"
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      setSeach((prev) => {
                                        return {
                                          ...prev,
                                          [alias]: value,
                                        };
                                      });
                                    }}
                                  />
                                </td>
                              )
                            )}
                          </tr>
                          {currentData?.length > 0 ? (
                            currentData?.map((item, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    color: "#888787",
                                  }}
                                >
                                  {indexOfFirstData + index + 1}
                                </td>
                                <td
                                  style={{
                                    color: "#888787",
                                  }}
                                >
                                  {item?.maEpc}
                                </td>
                                <td
                                  style={{
                                    color: "#888787",
                                  }}
                                >
                                  {item?.maPhieuNhapKho}
                                </td>
                                <td
                                  style={{
                                    color: "#888787",
                                    width: "unset",
                                  }}
                                >
                                  {item?.maPP}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <td
                              className="align-center"
                              colSpan={DanhSachTemRFID?.titles?.length + 1}
                            >
                              {lang["not found"]}
                            </td>
                          )}
                        </>
                      </tbody>
                    </Table>
                    {DanhSachTemRFID && DanhSachTemRFID?.fields?.length > 0 && (
                      <Pagination
                        total={DanhSachTemRFID?.fields?.length}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        paginate={paginate}
                        lang={lang}
                      />
                    )}
                  </>
                )}
              </>
              {/* <>
                <div className={styles.title}>đơn vị sản xuất</div>
                <div className={styles.branch_name}>{DonViSanXuat?.Ten}</div>
                <div>
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className={styles.icon}
                  />
                  Địa chỉ:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.DiaChi}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={faPhone} className={styles.icon} />
                  Số điện thoại:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.SoDienThoai}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                  Email:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    {DonViSanXuat?.Email}
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={faGlobe} className={styles.icon} />
                  Website:
                  <span
                    className={styles.custom_span}
                    style={{ paddingLeft: "10px" }}
                  >
                    <a
                      className={styles.custom_a}
                      href={DonViSanXuat?.Website}
                      target="_blank"
                    >
                      {DonViSanXuat?.Website}
                    </a>
                  </span>
                </div>
              </> */}
            </>
          )}
        </div>
      </main>
    </>
  );
}
